/**
 * Move quantity selector below submit button group
 * Moves .product__item.product__quantity element from source container to the first position of target container
 * And applies corresponding styles
 * 
 * Updated: Only runs on product detail pages to prevent console errors on other pages
 */

// Wait for DOM to fully load
document.addEventListener('DOMContentLoaded', function() {
    // Only execute on product detail pages
    if (!document.body || !document.body.classList.contains('template-product')) {
        console.log('ℹ️ Skipped: Current page is not a product detail page');
        return;
    }
    
    // Find source container - div containing quantity selector
    const sourceContainer = document.querySelector('.product__controls-group.product__controls-group-quanity.product__block.product__block--medium.animation-fade-up-reveal');
    
    // Find target container - submit button group
    const targetContainer = document.querySelector('.product-form__controls-group.product-form__controls-group--submit');
    
    // Find quantity element to move
    const quantityElement = document.querySelector('.product__item.product__quantity');
    
    // Find submit button container
    const submitItem = document.querySelector('.product-form__item.product-form__item--submit');
    
    // Check if all elements exist
    if (sourceContainer && targetContainer && quantityElement) {
        // 1. Hide source container
        sourceContainer.style.display = 'none';
        console.log('✅ Source container hidden');
        
        // 2. Set target container to flex layout
        targetContainer.style.display = 'flex';
        console.log('✅ Target container set to flex layout');
        
        // 3. Set submit button container styles
        if (submitItem) {
            submitItem.style.width = '80%';
            submitItem.style.paddingLeft = '1%';
            console.log('✅ Submit button container styles applied');
        }
        
        // 4. Move quantity element to first position of target container
        targetContainer.insertBefore(quantityElement, targetContainer.firstChild);
        
        console.log('✅ Quantity selector successfully moved below submit button group');
    } else {
        console.error('❌ Required elements not found, please check page structure');
        
        // Debug information
        if (!sourceContainer) {
            console.error('Source container not found: .product__controls-group.product__controls-group-quanity.product__block.product__block--medium.animation-fade-up-reveal');
        }
        if (!targetContainer) {
            console.error('Target container not found: .product-form__controls-group.product-form__controls-group--submit');
        }
        if (!quantityElement) {
            console.error('Quantity element not found: .product__item.product__quantity');
        }
        if (!submitItem) {
            console.error('Submit button container not found: .product-form__item.product-form__item--submit');
        }
    }
    
    // Execute move element to product-fabric functionality
    moveElementToProductFabric();
    
    // Replace "Color" with "Colour" on product labels
    replaceColorLabels();
});

/**
 * Move jdgm-widget element to product-fabric container as last child element
 */
function moveElementToProductFabric() {
    // Only execute on product detail pages
    if (!document.body || !document.body.classList.contains('template-product')) {
        return;
    }
    
    // Element to move
    const elementToMove = document.querySelector('.jdgm-widget.jdgm-preview-badge');
    
    // Target container
    const targetContainer = document.querySelector('.product-fabric');
    
    // Check if element and target container exist
    if (elementToMove && targetContainer) {
        // Move element to last position of target container
        targetContainer.appendChild(elementToMove);
        console.log('✅ jdgm-widget element successfully moved to .product-fabric container as last child element');
    } else {
        console.error('❌ Failed to move jdgm-widget element to product-fabric');
        
        // Debug information
        if (!elementToMove) {
            console.error('Element to move not found: .jdgm-widget.jdgm-preview-badge');
        }
        if (!targetContainer) {
            console.error('Target container not found: .product-fabric');
        }
    }
}

// /**
//  * Replace "Color" with "Colour" on product labels
//  */
// function replaceColorLabels() {
//     // Only execute on product detail pages
//     if (!document.body || !document.body.classList.contains('template-product')) {
//         return;
//     }
    
//     // Find all product labels that contain "Color"
//     const productLabels = document.querySelectorAll('.product__label');
//     let replacedCount = 0;
    
//     productLabels.forEach(label => {
//         if (label.textContent.trim() === 'Color') {
//             const oldText = label.textContent;
//             label.textContent = 'Colour';
//             replacedCount++;
            
//             // Only log if DEBUG object exists
//             if (typeof DEBUG !== 'undefined' && DEBUG.log) {
//                 DEBUG.log('Replaced label text from:', oldText, 'to: Colour', label);
//             } else {
//                 console.log('Replaced label text from:', oldText, 'to: Colour');
//             }
//         }
//     });
    
//     if (replacedCount > 0) {
//         console.log(`✅ Replaced ${replacedCount} "Color" label(s) with "Colour"`);
//     }
// }

/**
 * Fallback solution: If main selectors fail, try other possible selectors
 */
function moveQuantityFallback() {
    // Try other possible selectors
    const alternativeSelectors = [
        '.product__quantity',
        '[data-quantity-input]',
        '.product__item',
        '.quantity-selector'
    ];
    
    for (let selector of alternativeSelectors) {
        const element = document.querySelector(selector);
        if (element) {
            const targetContainer = document.querySelector('.product-form__controls-group--submit') || 
                                  document.querySelector('.product-form__controls-group');
            
            if (targetContainer) {
                // Apply styles
                targetContainer.style.display = 'flex';
                
                // Set submit button container styles
                const submitItem = document.querySelector('.product-form__item.product-form__item--submit');
                if (submitItem) {
                    submitItem.style.width = '80%';
                    submitItem.style.paddingLeft = '1%';
                }
                
                targetContainer.insertBefore(element, targetContainer.firstChild);
                console.log(`✅ Successfully moved quantity selector using fallback selector ${selector} and applied styles`);
                return true;
            }
        }
    }
    
    console.error('❌ All fallback selectors failed');
    return false;
}

